import React, {useEffect} from 'react'


const useNormalizePosition = () => {

    const [currentNormalizedPosition, setCurrentNormalizedPosition] = React.useState(0)
    const [maxValue, setMaxValue] = React.useState(0)
    const [progress, setProgress] = React.useState(0)

    useEffect(() => {
      //  console.log(maxValue, progress, maxValue -Math.floor(maxValue * progress))
        setCurrentNormalizedPosition(Math.floor(maxValue - (maxValue * progress))+ .9)

    }, [maxValue, progress])


    return [currentNormalizedPosition, setMaxValue, setProgress]

}
export default useNormalizePosition;
